import React from "react";
import { Tooltip, tooltipClasses, styled, TooltipProps } from "@mui/material";

// Styled Tooltip für Bootstrap-Look
const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.secondary.main,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.secondary.main,
    padding: 10,
  },
}));

const BootstrapTooltip = ({ children, ...props }: TooltipProps) => {
  return <StyledTooltip {...props}>{children}</StyledTooltip>;
};

export default BootstrapTooltip;
